import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n<path d=\"M3 8H13\" stroke=\"#424242\" stroke-width=\"2\" />\n<path d=\"M8 13L8 3\" stroke=\"#424242\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol